const PrimaryHost = "https://apis.intastellarsolutions.com";
const LoginHost = "https://apis.intastellaraccounts.com";
const ScannerHost = "https://www.intastellarconsents.com";

export { PrimaryHost, LoginHost, ScannerHost }